import { cn } from "@wags/ui/ui-utils";
import type { ReactNode, Ref } from "react";

export function ProviderPageShell({
    ref,
    className,
    children,
}: {
    ref?: Ref<HTMLDivElement>;
    className?: string;
    children: ReactNode;
}) {
    return (
        <div
            ref={ref}
            className={cn(
                "min-h-dvh w-full flex flex-col bg-maltese-white",
                className,
            )}
        >
            {children}
        </div>
    );
}
